/**
 * Field Classes
 */

const fieldClasses = 'group relative flex flex-wrap outline outline-1 cursor-text';

/**
 * Icon
 */

const fieldIconClasses = 'transition-colors duration-300';

/**
 * Common Theme
 */

const inputFieldCommonTheme = {
  fieldCommonClasses: fieldClasses,
  fieldIconCommonClasses: fieldIconClasses,
};

export default inputFieldCommonTheme;
